export class MicrogamingPreloaderUtils {

	public static getContentUrl(): string {
		return (window as any).V.API.UrlHelper.getContentUrl();
	}

	public static getPublisherPath(): string {
		return (window as any).mgsConfig.branding.publisher.path;
	}

	public static getMicrogamingResolution(): string {
		const fallbackResolution: string = '1024x768';
		const detectedResolution = (window as any).mgsCasinoParams.resolution;
		const supportedResolutions = ['1024x768', '1136x640'];
		if (supportedResolutions.indexOf(detectedResolution) !== -1) {
			return detectedResolution;
		}

		return fallbackResolution;
	}

	public static getPublisherLogoPathRoot(includeResolution: boolean): string {
		if (includeResolution) {
			return this.getContentUrl() + `${this.getPublisherPath()}/${this.getMicrogamingResolution()}`;
		}

		return this.getContentUrl() + `${this.getPublisherPath()}`;
	}

	public static createImage(name: string): HTMLImageElement {
		const image: HTMLImageElement = new Image();

		image.id = name;
		image.style.position = 'absolute';

		return image;
	}

	public static createPublisherLogo(imageName: string, fallback: string, includeResolution: boolean = true): HTMLImageElement {
		const logo: HTMLImageElement = this.createImage(imageName);

		logo.src = `${this.getPublisherLogoPathRoot(includeResolution)}/${imageName}`;

		logo.onerror = () => {
			logo.src = fallback;
			logo.onerror = () => {
			};
		};

		return logo;
	}

	public static createDisclaimer(): HTMLImageElement {
		const logo: HTMLImageElement = this.createImage('disclaimer');
		logo.src = this.getContentUrl() + this.getPublisherPath() + 'disclaimer.png';

		return logo;
	}

	public static createBar(id: string, color: string, transform: string): HTMLElement {
		const bar: HTMLElement = document.createElement('div');

		bar.id = id;
		bar.className = id;
		bar.style.position = 'absolute';
		bar.style.backgroundColor = color;
		bar.style.webkitTransform = transform;
		bar.style.transform = transform;

		return bar;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/loader/MicrogamingPreloaderUtils.ts